import { jsx as _jsx } from "nativewind/jsx-runtime";
import React from 'react';
import { Text, View } from 'react-native';
import { cn } from '@/utils/cn';
export function MyChallengeBadge() {
    return (_jsx(Badge, { className: "bg-brand-25", textClassName: "text-white", children: "\uB098\uC758 \uCC4C\uB9B0\uC9C0" }));
}
export function ChallengeStatusBadge({ status, }) {
    switch (status) {
        case 'InProgress':
            return (_jsx(Badge, { className: "bg-[#E5F1FF]", textClassName: "text-brand-30", children: "\uC9C4\uD589 \uC911" }));
        case 'Upcoming':
            return (_jsx(Badge, { className: "bg-success-10", textClassName: "text-success-30", children: "\uC624\uD508 \uC608\uC815" }));
        case 'Closed':
            return (_jsx(Badge, { className: "bg-gray-v2-20", textClassName: "text-gray-v2-60", children: "\uC885\uB8CC\uB41C \uCC4C\uB9B0\uC9C0" }));
        default:
            return status;
    }
}
function Badge({ className, textClassName, children, }) {
    return (_jsx(View, { className: cn('px-[6px] py-[4px] rounded-[4px]', className), children: _jsx(Text, { className: cn('text-[12px] leading-[16px] tracking-[-0.24px] font-pretendard-medium', textClassName), children: children }) }));
}
